<template>
    <div class="my-3 bg-white rounded border table-responsive">
        <table class="table table-hover mb-0">
            <thead>
                <tr>
                    <th scope="col" class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Ad</th>
                    <th scope="col" class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Start date</th>
                    <th scope="col" class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">End date</th>
                    <th scope="col" class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Type</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="Object.keys(events).length">
                    <tr v-for="(event, index) in events" :key="index">
                        <td class="align-middle">
                            <a :href="'/ads/' + event.ad.id + '/detail'">{{ event.ad.name }} ({{ event.ad.reference }})</a>
                        </td>
                        <td class="align-middle">
                            <span class="text-nowrap font-weight-normal text-muted">{{ event.start_date }}</span>
                        </td>
                        <td class="align-middle">
                            <span class="text-nowrap font-weight-normal text-muted">{{ event.end_date}}</span>
                        </td>
                        <td class="align-middle">
                            <span class="text-nowrap font-weight-normal text-muted">{{ event.description }}</span>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td  class="text-nowrap font-weight-normal text-muted text-center" colspan="4">No events available</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        events: { type:Array, required:true}
    },
}
</script>

<style>

</style>